import { useAction } from './useAction';
import { useCallback } from 'react';
import { AMPLITUDE_EVENT, amplitudeActions, AmplitudeEvent } from '@sonar-software/sonar-analytics';

export function useAmplitude(): (
	event: AMPLITUDE_EVENT | AmplitudeEvent<Record<string, unknown> | undefined>,
	data?: Record<string, unknown>
) => void {
	const logEventAction = useAction(amplitudeActions.requestAmplitudeEvent);

	return useCallback(
		(event: AMPLITUDE_EVENT | AmplitudeEvent, data?: Record<string, unknown>) => {
			if (typeof event === 'string') {
				logEventAction({
					data,
					id: event
				});
			} else {
				logEventAction(event);
			}
		},
		[ logEventAction ]
	);
}
